import { createSelector } from '@ngrx/store';
import { selectAllTrips } from './entity-store-selectors';
import { selectOperationById } from './operation-selectors';
import { selectOperationByCardNumber } from './shared-selectors';

export function selectTripByTripId(tripId: string) {
  return createSelector(selectAllTrips, (trips) => {
    return trips.valueSeq().find((t) => t.id === tripId);
  });
}

export function selectTripByOperationId(operationId: string) {
  return createSelector(selectAllTrips, (trips) => {
    return trips.valueSeq().find((t) => t.operationId === operationId);
  });
}

export function selectPrimaryTripByOperationId(operationId: string) {
  return createSelector(selectOperationById(operationId), selectAllTrips, (operation, trips) => {
    return operation == null
      ? undefined
      : trips.find(
          (trip) => trip.operationId === operation.id && trip.vehicleId === operation.vehicleId,
        );
  });
}

export function selectPrimaryTripByCardNumber(cardNumber: string) {
  return createSelector(
    selectOperationByCardNumber(cardNumber),
    selectAllTrips,
    (operation, trips) => {
      return operation == null
        ? undefined
        : trips.find(
            (trip) => trip.operationId === operation.id && trip.vehicleId === operation.vehicleId,
          );
    },
  );
}
